import { throttle } from './helpers/throttle'

if (!navigator.userAgent.match(/BlackBerry|BB|PlayBook/i)) {
  if (window.innerWidth >= 1025) {
    window.addEventListener('scroll', throttle(parallax, 14));
    
    function parallax() {
      let scrolled = window.pageYOffset;
      const mtn = document.querySelector('.header__top');
      const sky = document.querySelector('.header__bg');

      let offset = scrolled * -0.125
      let scale = scrolled * 0.00015

      if (scrolled < 1200) {
        mtn.style.transform = `translateY(${offset}px)`
        sky.style.transform = `scale(${1 + scale})`
      }
    };
  }
}